// eslint-disable-next-line import/named
import {
  BranchQuoteSupport,
  BranchQuoteSupportItemType,
  BranchQuoteSupportStatus,
  QuoteItemConversation,
  QuoteItemConversationType,
  ViewConversationEntry
} from '../../../api/dealer-api-interface-franchisee';
import { customElement, query, state } from 'lit/decorators.js';
import { DevelopmentError } from '../../../../webmodule-common/other/development-error';
import { emptyGuid, newGuid } from '../../../../webmodule-common/other/api/guid';
import { ETOEditorSavedEventData, WebModuleFranchiseeETOEditor } from './franchisee-engineered-to-order';
import { EventTemplate } from '../../../../webmodule-common/other/ui/events';
import {
  firstValidString,
  flagInSet,
  isEmptyOrSpace
} from '../../../../webmodule-common/other/ui/string-helper-functions';
import { FranchiseeQuoteContainerManager } from '../data/franchisee-quote-manager';
import { getApiFactory } from '../../../api/api-injector';
import { getCurrentUser } from '../../../../webmodule-common/other/api/current-user';
import {
  getQuoteItemTab,
  isSpecialItem,
  isSSI,
  isSupplierSpecialItem
} from '../../../quotes/data/quote-helper-functions';
import { html, LitElement, PropertyValueMap } from 'lit';
import { LangFranchiseeEngineeredToOrder } from '../../../../localization/scripts/dealer-franchisee/quotes/views/franchisee-engineered-to-order-lang';
import { LineItemView } from '../../../quotes/views/line-item-view';
import { nowServer } from '../../../../webmodule-common/other/datetime-converter';
import { quoteItemContentType } from '../../../quotes/data/default-quote-item-content-type';
import { QuoteItemType } from '../../../api/dealer-api-interface-quote';
import {
  QuoteFrameDataProvider,
  Snippet,
  V6CustomItemRequestType,
  v6FrameUserMode,
  V6QuoteFrameEditor,
  V6QuoteFrameEditorData
} from '../../../../webmodule-common/interop/webmodule-interop';
import { userDataStore } from '../../common/current-user-data-store';
import { addV6DebugInformation, clearAllV6DebugInformation } from '../../../quotes/v6/v6-debug-information';
import { v6BootLoaderWithFailMsg, v6Editors } from '../../../v6config/v6config';
import { getQuoteSuppliers } from '../../../quotes/quote-service';

import { LangV6QuoteItemFrameView } from '../../../../localization/scripts/quotes/v6/v6-quote-item-frame-view-lang';
import { V6FranchiseeQuoteProviderData } from '../data/franchisee-quote-provider-data';
import { userSecurity } from '../../../../webmodule-common/other/api/user-security';
import { getV6QuoteItemForContainer } from '../../../quotes/data/v6/helper-functions';
import { quoteSupplierProvider } from '../../../quotes/data/quoteSupplierProvider';
import { toJsonStr } from '../../../../webmodule-common/other/blob-converters';
import { offline } from '../../../../webmodule-common/other/ui/offline';

import { information } from '../../../../webmodule-common/other/ui/modal-option';

/**
 *
 * This is the new format Engineered To Order item,
 * which blends the basic special item, with the new
 * ETO Request
 */
@customElement('wm-engineeredtoorderlineitemview')
export class EngineeredToOrderLineItemView extends LineItemView implements QuoteFrameDataProvider {
  @state()
  protected branchQuoteSupport?: BranchQuoteSupport;
  @state()
  protected masterDocument?: ViewConversationEntry;
  protected franchiseeApi = getApiFactory().franchisee();
  @state()
  protected quoteItemConversationLink?: QuoteItemConversation | null;
  protected dataPrimaryKey = newGuid();
  supplierSelector?: V6CustomItemRequestType;
  @state() v6Editor: V6QuoteFrameEditor | null = null;
  supplierOffline: boolean;

  get preSelectionFrameReference() {
    if (!this.supplierSelector) return undefined;
    return {
      reference: this.supplierSelector.objectReference,
      description: this.supplierSelector.note
    };
  }

  /** QuoteFrameDataProvider */
  get supplierReferenceOverrideKey(): string {
    //the quote owner is the branch ID, which is what we are tying our v6 customer to
    return this.quoteManager.quote.quoteOwnerId;
  }
  get quoteItem() {
    if (!this.quoteItemContainer) return undefined;
    return getV6QuoteItemForContainer(this.quoteItemContainer);
  }

  propertiesTemplate() {
    return html``;
  }
  get quoteIGUs(): unknown {
    const data = this.quoteManager.quoteProviderData() as V6FranchiseeQuoteProviderData;
    return data.igu ?? [];
  }

  get quoteDefaults(): unknown {
    const data = this.quoteManager.quoteProviderData() as V6FranchiseeQuoteProviderData;
    return data.defaultOptions ?? [];
  }
  get userMode(): string | undefined {
    if (userSecurity().isPowerUser()) return v6FrameUserMode.powerUser;
    else return v6FrameUserMode.standardUser;
  }

  get quantity(): number {
    if (!this.quoteItemContainer) return 1;
    try {
      const uiValue = Math.max(1, this.etoEditor?.quantityFromUi ?? 1);
      return uiValue;
    } catch {
      return this.quoteItemContainer?.item.quantity ?? 1;
    }
  }
  get supplierCostPrice(): number {
    return this.quoteItemContainer?.price.supplierGrossSingleUnitCost ?? 0;
  }
  customData(): { [key: string]: any } {
    return {
      isSpecialItem: true
    };
  }
  get thumbnailURL() {
    return '';
  }
  /** End QuoteFrameDataProvider */

  get qcm(): FranchiseeQuoteContainerManager {
    return this.quoteManager as FranchiseeQuoteContainerManager;
  }

  get forceReadonly() {
    return this.quoteManager.isReadonly() || this.ticketClosed;
  }

  get quoteSetId() {
    return this.quoteManager.quote.quoteSetId;
  }

  get branchQuoteSupportId(): string {
    return this.branchQuoteSupport?.id ?? this.quoteItemContainer?.item.id ?? emptyGuid;
  }

  public get hasPropertyDialog(): boolean {
    //if (this.quoteItemContainer && isSSI(this.quoteItemContainer.item))
    return true;
    //return false;
  }

  public get hasModalEditDialog(): boolean {
    return false;
  }

  get quoteId() {
    return this.quoteManager.quoteId;
  }
  protected get ticketClosed() {
    return (
      !this.branchQuoteSupport ||
      // eslint-disable-next-line no-bitwise
      flagInSet(this.branchQuoteSupport.status, BranchQuoteSupportStatus.Cancelled | BranchQuoteSupportStatus.Resolved)
    );
  }

  @query('#editor')
  etoEditor?: WebModuleFranchiseeETOEditor;

  override isDataReadonly(): boolean {
    return (
      super.isDataReadonly() ||
      this.branchQuoteSupport?.status == BranchQuoteSupportStatus.Resolved ||
      this.branchQuoteSupport?.status == BranchQuoteSupportStatus.Cancelled
    );
  }

  get readonly(): boolean {
    return this.isDataReadonly() || this.supplierOffline || super.readonly || this.forceReadonly;
  }

  protected async readyToClose(): Promise<boolean> {
    if (this.v6Editor?.busy) {
      await information(LangV6QuoteItemFrameView.pleaseWaitUntilProcessingComplete());
      return false;
    }
    return true;
  }

  buttonMenu(): Snippet {
    return this.etoEditor
      ? html` ${this.abandonAndCloseButton()} ${this.etoEditor.branchSupportActionsTemplate()} `
      : html``;
  }

  protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): Promise<void> {
    await super.firstUpdated(_changedProperties);
    if (this.etoEditor) {
      this.etoEditor.v6Editor = this.v6Editor;
      this.requestUpdate();
    }
  }

  async dispose(): Promise<void> {
    if (!this.readonly) this.v6Editor?.releaseResources();
    this.v6Editor = null;
    await clearAllV6DebugInformation('WebModuleFranchiseeETOEditor');

    await super.dispose();
  }
  discardLabel(): unknown {
    if (this.isDataReadonly()) return LangFranchiseeEngineeredToOrder.close();

    return this.isNew() ? LangFranchiseeEngineeredToOrder.discard() : LangFranchiseeEngineeredToOrder.discardChanges();
  }

  public async loadBranchQuoteSupport(quoteItemId: string): Promise<boolean> {
    //copied ETO use the same conversation
    const supportData = await this.qcm.needsQuoteSupport(); //always reload a fresh copy

    this.quoteItemConversationLink = await this.franchiseeApi.quoteItemConversationLink({
      quoteId: this.quoteManager.quote.id,
      quoteItemId: quoteItemId,
      type: QuoteItemConversationType.EngineeredToOrder,
      conversationId: null
    });
    /*
    this.quoteItemConversationLink = supportData?.conversationLinks.find(
      x => x.quoteItemId === quoteItemId && x.type === QuoteItemConversationType.EngineeredToOrder
    );
*/
    if (!this.quoteItemConversationLink) return false;

    this.branchQuoteSupport = supportData?.items.find(
      x => x.conversationId === this.quoteItemConversationLink?.conversationId
    );
    if (!this.branchQuoteSupport) return false;
    this.masterDocument = supportData?.masterDocuments.find(
      x => x.id === this.branchQuoteSupport?.masterDocumentConversationId
    );

    if (this.branchQuoteSupport && !this.branchQuoteSupport.masterDocumentConversationId) {
      this.branchQuoteSupport.masterDocumentConversationId = newGuid();

      this.masterDocument = (
        await this.franchiseeApi.addConversationEntry({
          attachments: [],
          branchQuoteSupportId: null,
          conversationEntryId: this.branchQuoteSupport.masterDocumentConversationId,
          conversationId: this.branchQuoteSupport.masterDocumentConversationId,
          draft: false,
          text: 'MASTERDOCUMENT',
          users: []
        })
      )?.conversationEntry;

      //deal with pre-update code. we can remove this down the line
      const newResult = await this.franchiseeApi.updateBranchQuoteSupport({
        quoteItemLink: null,
        branchQuoteId: this.quoteId,
        branchQuoteSupportId: this.branchQuoteSupport.id,
        masterDocumentConversationId: this.branchQuoteSupport.masterDocumentConversationId,
        status: null,
        subject: null,
        quoteItemIdToDetach: null,
        conversationEntries: null
      });
      this.branchQuoteSupport = newResult?.branchQuoteSupport;
      this.masterDocument = newResult?.masterDocument ?? undefined;
    }
    return this.branchQuoteSupport !== undefined && this.masterDocument != undefined;
  }
  //only used for new frames
  private _id: string = newGuid();

  get id(): string {
    return this.quoteItemContainer?.item.id ?? this._id;
  }

  public async prepareEditor(): Promise<void> {
    if (this.quoteItemContainer && isSSI(this.quoteItemContainer.item)) {
      this._readyToEdit = false;
      return;
    }

    if (!this.quoteItemContainer) {
      let providerData: string | null = null;
      if (this.usingV6 && this.v6Editor) {
        let details: V6QuoteFrameEditorData | null = null;
        try {
          details = await this.v6Editor.commit();
          providerData = details ? (toJsonStr(details.quoteItem) ?? null) : null;
        } catch {
          await offline();
          return;
        }
      }
      this.createMockQuoteItem(providerData);
    }

    if (this.quoteItemContainer) {
      this.dataPrimaryKey = this.quoteItemContainer.item.id;

      if (this._readyToEdit && this.quoteItemContainer && this.usingV6) {
        await addV6DebugInformation('QuoteItemFrameViewForV6', {
          quoteItemId: this.quoteItemContainer.item.id,
          quoteItemPosition: this.quoteManager.itemPosition(this.quoteItemContainer.item.id)?.toString() ?? '',
          quoteTitle: this.quoteItemContainer.item.title,
          quoteItemDescription: this.quoteItemContainer.item.description
        });
      }

      if (!(await this.loadBranchQuoteSupport(this.dataPrimaryKey))) {
        const transactionDate = nowServer();
        const userId = getCurrentUser()?.id ?? emptyGuid;
        this.createMockBranchQuoteSupport(transactionDate, userId);
      }
    }

    if (!this.quoteItemContainer) return;
    if (!isSpecialItem(this.quoteItemContainer.item))
      throw new DevelopmentError(
        `special-line-item-view, ${this.quoteItemContainer.item.description} is not a special line item.`
      );
    if (this.quoteItemContainer.item.quoteItemContentType !== quoteItemContentType.specialItem)
      throw new DevelopmentError(`quote item ${this.quoteItemContainer.item.title} is not a special line item`);

    //load after populating all other data and state correctly to ensure the getQuoteFrameOptionsService preloads correctly
    if (this.usingV6) {
      if (await v6BootLoaderWithFailMsg()) {
        if (!this.readonly) {
          const suppliers = await getQuoteSuppliers();
          this.supplierOffline = !(
            suppliers.find(x => x.supplierId === this.quoteManager.quote.supplierId)?.online ?? false
          );
          if (this.supplierOffline) await information(LangV6QuoteItemFrameView.supplierOfflineReadonly());
        }
        await addV6DebugInformation('WebModuleFranchiseeETOEditor', {
          quoteItemId: this.id,
          quoteItemPosition: this.quoteManager.itemPosition(this.id, true)?.toString() ?? '',
          quoteItemTitle: 'New Item'
        });
        this.v6Editor = await v6Editors().getQuoteFrameOptionsService(this);

        if (this.v6Editor) {
          this.v6Editor.ui.addEventListener('v6frameview', e => {
            const ev: CustomEvent = e as CustomEvent;
            if (ev.detail.error && ev.detail.shutdownRequired) this.abandonAndClose(true);
          });
        }
      }
      this._readyToEdit = this.v6Editor !== null && this.v6Editor !== undefined;
    } else this._readyToEdit = true;

    this.requestUpdate();
  }

  public isTab(): boolean {
    return (this.quoteItemContainer && !isSSI(this.quoteItemContainer.item)) ?? false;
  }

  get usingV6(): boolean {
    return this.supplierSelector !== undefined || isSupplierSpecialItem(this.quoteItemContainer?.item);
  }

  async prepareForSave(): Promise<void> {
    if (this.forceReadonly) return;
    await this.etoEditor?.prepareForSave();
  }

  public internalDataChanged(): boolean {
    return (this.etoEditor?.hasDataChanged ?? false) || this.quoteManager.changedItem(this.quoteItemContainer?.item.id);
  }

  createMockQuoteItem(providerData?: string | null): void {
    const transactionDate = nowServer();
    const userId = getCurrentUser()?.id ?? emptyGuid;
    this.quoteItemContainer = {
      item: {
        comment: '',
        commonId: newGuid(),
        dateCreated: transactionDate,
        description: '',
        id: this.dataPrimaryKey,
        isRestrictedToPowerUser: false,
        itemType: this.usingV6 ? QuoteItemType.Provider : QuoteItemType.Basic,
        lastModifiedDate: transactionDate,
        lastModifiedUserId: userId,
        providerReferenceId: emptyGuid,
        quantity: 1,
        quoteId: this.quoteManager.quoteId,
        quoteItemContentType: quoteItemContentType.specialItem,
        recordVersion: '',
        serviceProvider: this.usingV6 ? quoteSupplierProvider.v6 : '',
        title: LangFranchiseeEngineeredToOrder.newSpecialItem(),
        virtualThumbnailPath: '',
        commentToManufacturer: null,
        isShippingItem: false,
        inlineDocuments: null
      },
      price: {
        breakdowns: null,
        calculatedGrossSellingPrice: 0,
        calculatedNetSellingPrice: 0,
        dateCreated: transactionDate,
        id: this.dataPrimaryKey,
        isTaxableItem: true,
        percentMarginOrMarkup: null,
        priceAdjustment: 0,
        quantityCost: 0,
        recordVersion: '',
        requiresRepricing: false,
        singleUnitCost: 0,
        sourceData: {},
        supplierGrossQuantityCost: 0,
        supplierGrossSingleUnitCost: 0,
        supplierNettQuantityCost: 0,
        supplierNettSingleUnitCost: 0,
        supplierPriceAdjustment: 0,
        supplierPriceAdjustmentEnabled: false,
        supplierPriceAdjustmentReason: null
      },
      buyInData: undefined,
      data: this.usingV6
        ? {
            id: this.dataPrimaryKey,
            dateCreated: transactionDate,
            lastModifiedDate: transactionDate,
            lastModifiedUserId: emptyGuid,
            providerData: providerData ?? null,
            recordVersion: ''
          }
        : null
    };
    this.createMockBranchQuoteSupport(transactionDate, userId);
  }

  protected isNew(): boolean {
    return !this.quoteItemContainer || isEmptyOrSpace(this.quoteItemContainer.item.recordVersion);
  }

  protected name() {
    return 'engineered-to-order';
  }

  protected getValidationErrors(): string[] {
    return this.etoEditor?.getValidationErrors() ?? [];
  }

  protected async revertChanges(): Promise<boolean> {
    return (await this.etoEditor?.revertChanges()) ?? true;
  }

  protected getCaption(): Snippet {
    return getQuoteItemTab(
      firstValidString(this.quoteItemContainer?.item.title, LangFranchiseeEngineeredToOrder.specialItem()),
      this.quoteManager.itemPosition(this.quoteItemContainer?.item.id)
    );
  }

  protected async internalSaveData(): Promise<boolean> {
    const result = (await this.etoEditor?.save()) ?? false;

    return result;
  }

  protected eventETOSaved = (e: CustomEvent<ETOEditorSavedEventData>) => {
    this.quoteItemContainer = e.detail.quoteItemContainer;
    this.branchQuoteSupport = e.detail.branchQuoteSupport;
    this.masterDocument = e.detail.masterDocument;
    this.quoteItemConversationLink = e.detail.quoteItemConversationLink;
    (this.v6Editor?.ui as LitElement)?.requestUpdate();
    this.refreshParent();
  };

  protected eventEtoStateChanged = () => {
    (this.v6Editor?.ui as LitElement)?.requestUpdate();
    this.refreshParent();
  };
  needSaveEvent = (e: CustomEvent<{ event: Promise<boolean> | null }>) => {
    e.detail.event = this.performAutoSave();
  };
  protected bodyTemplate(): EventTemplate {
    return html` <wmview-franchisee-eto-editor
      id="editor"
      @wm-event-needsave=${this.needSaveEvent}
      @wm-event-saved="${this.eventETOSaved}"
      @wm-event-changed="${this.eventEtoStateChanged}"
      .quoteItemContainer="${this.quoteItemContainer ?? undefined}"
      .branchQuoteSupport="${this.branchQuoteSupport}"
      .masterDocument="${this.masterDocument}"
      .quoteManager="${this.qcm}"
      .isNewETO="${this.isNew()}"
      .quoteItemConversationLink="${this.quoteItemConversationLink}"
    ></wmview-franchisee-eto-editor>`;
  }

  private createMockBranchQuoteSupport(transactionDate: string, userId: string) {
    if (!this.quoteItemContainer) throw new DevelopmentError('ETO QuoteItemContainer cannot be null');
    const masterDocumentId = newGuid();
    this.branchQuoteSupport = {
      quoteItemLink: null,
      branchQuoteId: this.quoteId,
      conversationId: this.quoteItemContainer.item.id,
      dateCreated: transactionDate,
      id: this.quoteItemContainer.item.id,
      lastModified: transactionDate,
      lastModifiedUserId: userId,
      createdUserId: userId,
      masterDocumentConversationId: masterDocumentId,
      recordVersion: '',
      status: BranchQuoteSupportStatus.Draft,
      subject: this.quoteItemContainer.item.title,
      type: BranchQuoteSupportItemType.EngineeredToOrder,
      assignedSupplierUserId: null
    };
    this.masterDocument = {
      attachments: [],
      conversationId: masterDocumentId,
      dateCreated: transactionDate,
      draft: false,
      editCount: 0,
      franchiseeId: userDataStore.franchisee.id,
      id: masterDocumentId,
      lastModified: transactionDate,
      systemUserId: userId,
      text: 'MASTERDOCUMENT',
      users: []
    };
    this.quoteItemConversationLink = {
      dateCreated: transactionDate,
      id: newGuid(),
      recordVersion: '',
      conversationId: this.quoteItemContainer.item.id,
      quoteItemId: this.quoteItemContainer.item.id,
      quoteId: this.quoteManager.quote.id,
      type: QuoteItemConversationType.EngineeredToOrder
    };
  }
}
